import { useTranslation } from "react-i18next";
import EventGeoFilter from "./EventGeoFilter";
import EventDateFilter from "./EventDateFilter";
import { getEventCityDisplayLabel, getEventCountryDisplayLabel } from "./eventGeoLabels";

const EventsFilters = ({
  isGeoOpen,
  isFilterOpen,
  onGeoOpen,
  onFilterOpen,
  onGeoClose,
  onFilterClose,
  selectedCountry,
  selectedCity,
  selectedMunicipalityId,
  selectedRadiusKm,
  geoCount,
  setGeoCount,
  dateCount,
  setDateCount,
  selectedDate,
  selectedCategories,
  selectedDiscoveryFilters,
  fixedEventKind = "",
  includeTeamConcepts = false,
  onDiscoveryFiltersChange,
  onCategoriesChange,
  viewType,
  isGuest,
  onLocationChange,
  onDateChange,
  onApply,
  theme,
  fullHeight = false,
  marketRegion = "EU",
  expandedHeader = false,
}) => {
  const { t } = useTranslation("events");
  const countryLabel = getEventCountryDisplayLabel(t, marketRegion, selectedCountry);
  const cityLabel = getEventCityDisplayLabel(t, selectedCity, marketRegion);
  const locationLabel = cityLabel
    ? selectedRadiusKm == null || Number(selectedRadiusKm) === 0
      ? cityLabel
      : `${cityLabel} · ${t("filters.geo.nearby")} ${selectedRadiusKm} km`
    : countryLabel;
  const activeFilterCount = Number(fixedEventKind !== "concept" && Boolean(selectedDate))
    + (selectedCategories?.length || 0)
    + Object.entries(selectedDiscoveryFilters || {}).filter(([key, value]) => !["participantAgeMax", "eventKind"].includes(key) && Boolean(value)).length;
  return (
    <div className="flex items-center justify-between gap-4 px-0 mb-2">
      <button
        className="flex min-w-0 items-center gap-1.5"
        aria-label={t("filters.geo.select_location_aria")}
        onClick={onGeoOpen}
      >
        <div className="flex min-w-0 items-center gap-1.5">
          <img
            src="/assets/events/location_filter.svg"
            alt={t("filters.geo.location_icon_alt")}
            className="h-5 w-5 shrink-0"
          />
          <span className="min-w-0 truncate text-sm font-medium text-white">{locationLabel}</span>
          <img
            src="/assets/events/down_arrow.svg"
            alt={t("filters.geo.dropdown_arrow_alt")}
            className="h-3 w-3 shrink-0"
          />
        </div>
      </button>
      <button
        className="flex shrink-0 items-center gap-1.5 text-sm font-semibold text-white"
        aria-label={t("filters.geo.open_filters_aria")}
        onClick={onFilterOpen}
      >
        <div className="flex items-center gap-1.5">
          <img
            src="/assets/events/filter_icon.svg"
            alt={t("filters.geo.filter_icon_alt")}
            className="h-4 w-4 shrink-0"
          />
          <span className="text-sm font-medium text-white">{t("filters.geo.filters_label")}</span>
          {activeFilterCount > 0 && (
            <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-white px-1 text-[11px] font-bold text-[#3E6FFB]" aria-label={t("discovery_filters.active_count", { count: activeFilterCount, defaultValue: `${activeFilterCount} active filters` })}>
              {activeFilterCount}
            </span>
          )}
        </div>
      </button>
      {isGeoOpen && (
        <EventGeoFilter
          expandedHeader={expandedHeader}
          fullHeight={fullHeight}
          onClose={onGeoClose}
          theme={theme}
          selectedCountry={selectedCountry}
          selectedCity={selectedCity}
          selectedMunicipalityId={selectedMunicipalityId}
          selectedRadiusKm={selectedRadiusKm}
          geoCount={geoCount}
          onLocationChange={onLocationChange}
          onApply={onApply}
          setGeoCount={setGeoCount}
          marketRegion={marketRegion}
        />
      )}
      {isFilterOpen && (
        <EventDateFilter
          expandedHeader={expandedHeader}
          fullHeight={fullHeight}
          onClose={onFilterClose}
          theme={theme}
          selectedDate={fixedEventKind === "concept" ? null : selectedDate}
          dateCount={dateCount}
          onDateChange={onDateChange}
          onApply={onApply}
          setDateCount={setDateCount}
          selectedCity={selectedCity}
          selectedMunicipalityId={selectedMunicipalityId}
          selectedCountry={selectedCountry}
          selectedRadiusKm={selectedRadiusKm}
          selectedCategories={selectedCategories}
          selectedDiscoveryFilters={selectedDiscoveryFilters}
          fixedEventKind={fixedEventKind}
          includeTeamConcepts={includeTeamConcepts}
          onDiscoveryFiltersChange={onDiscoveryFiltersChange}
          onCategoriesChange={onCategoriesChange}
          viewType={viewType}
          isGuest={isGuest}
        />
      )}
    </div>
  );
};

export default EventsFilters;
